import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TeamService} from '../service/team.service';
import {DelegateSummaryModel} from '../models/delegate.model';
import {TasksModel} from '../../tasks/models/tasks.model';
import {TasksService} from '../../tasks/tasks.service';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation, fadeInUpBigOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserJourneyModel, UserJourneysModel} from '../../journey/models/journey-page.model';
import {AnalyticsService} from '../../../services/analytics.service';
import {JourneyService} from '../../journey/service/journey.service';
import {AlertController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {EventsService} from '../../../services/events.service';

@Component({
  selector: 'app-team-details-page',
  templateUrl: './team-details.page.html',
  styleUrls: ['./team-details.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300})
  ]
})
export class TeamDetailsPage implements OnInit {

  @Output() doChangeSaveButton: EventEmitter<any> = new EventEmitter();

  data: UserJourneysModel = null;
  delegateId = 0;
  teamList: DelegateSummaryModel[] = [];
  customListData: Array<any> = [];

  isFirstMember = true;
  isLastMember = true;
  isSaveList = false;
  nextDelegateId = 0;
  prevDelegateId = 0;

  item1 = {
    id: 1,
    del_id: 1,
    task: true,
    click: true,
    status: true,
    section: 'interaction',
    title: 'Task 1',
    title_for_manager: 'What percentage of "no decision" losses are due to indecision?',
    icon: 'monitor',
  } as TasksModel;

  item2 = {
    id: 1,
    del_id: 1,
    task: true,
    click: true,
    status: false,
    section: 'interaction',
    title: 'Task 1',
    title_for_manager: 'A big driver of indecision is when…',
    icon: 'monitor',
  } as TasksModel;

  item3 = {
    id: 1,
    del_id: 1,
    task: true,
    click: false,
    status: false,
    section: 'interaction',
    title: 'Task 1',
    title_for_manager: 'In what part of the sales process is indecision most likely to affect buyers?',
    icon: 'monitor',
  } as TasksModel;

  item4 = {
    id: 1,
    del_id: 1,
    task: true,
    click: true,
    status: true,
    section: 'interaction',
    title: 'Task 1',
    title_for_manager: 'Based on the above scenario, how would you rate the depth, breadth, and intensity of indecision?',
    icon: 'monitor',
  } as TasksModel;

    constructor(
      private analytics: AnalyticsService,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private teamService: TeamService,
      private journeyService: JourneyService,
      private alertController: AlertController,
      private translate: TranslateService,
      private event: EventsService,
    ) {
    }

    ngOnInit() {
      this.delegateId = parseInt(this.activatedRoute.snapshot.paramMap.get('delegateId'), 10);
      if (this.delegateId < 1) {
        this.router.navigate(['/team']);
      }

      this.teamService.getUserJourneys(this.delegateId)
        .then(data => {
          this.data = data;
        });

      this.teamService.getMyTeamListModel().then(data => {
        this.teamList = data;
        this.updateButtonStatus();
      });
    }

    ionViewDidEnter() {
      this.analytics.trackView('Stuff member');
    }

    updateButtonStatus() {
      this.prevDelegateId = 0;
      this.nextDelegateId = 0;
      let delegateId = 0;

      this.teamList.forEach((member, index) => {
        if (member.delegate.id === this.delegateId) {
          delegateId = this.delegateId;
        } else {
          if (member.delegate.template_id > 0) {
            if (delegateId === 0) {
              this.prevDelegateId = member.delegate.id;
            } else if (this.nextDelegateId === 0) {
              this.nextDelegateId = member.delegate.id;
            }
          }
        }
      });
    }

    prevTeamMember() {
      if (this.prevDelegateId) {
        this.router.navigate(['/team/details/' + this.prevDelegateId]);
      }
    }

    nextTeamMember() {
      if (this.nextDelegateId) {
        this.router.navigate(['/team/details/' + this.nextDelegateId]);
      }
    }

    onSaveList() {
      if (this.customListData.length === 0) {
        this.event.publish('form:saved', {name: 'teamDetails'});
        return false;
      }

      this.journeyService.savePageData(this.customListData)
        .then(responce => {
          if (responce !== null) {
            this.event.publish('form:saved', {name: 'teamDetails'});

            this.isSaveList = false;
            this.customListData = [];

            this.alertController.create({
              header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
              message: this.translate.instant(responce.message),
              buttons: [this.translate.instant('__ALERT_SUCCESS_BUTTON__')]
            }).then(a => a.present());
          }
        })
        .catch(e => {

        });
    }

    onFormChange(value) {
      this.event.publish('form:changed', 'team:details');
      this.customListData = this.customListData.filter(item => item.section_id !== value.section_id);
      this.customListData.push(value);
      this.isSaveList = true;
    }
  };
